export enum SalesChannel {
  KIOSKPOLIS = 'KIOSKPOLIS',
  YANOSIK = 'YANOSIK',
  INTERCARS = 'INTERCARS',
  BANKIER = 'BANKIER',
  OLX = 'OLX',
  MPAY = 'MPAY',
  SKYCASH = 'SKYCASH',
  CARONE = 'CARONE',
  NESTBANK = 'NESTBANK',
}
